import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation ,Link } from 'react-router-dom';


import PropTypes from 'prop-types';





const Footer = () => {

 
    return (
        <div className="main-footer">
           {/* <p>Copyright © <Link to="https://electronikmedia.com/" target="_blank">electronikmedia</Link></p> */}
        </div>


  )
}

export default Footer

